export default "__VITE_ASSET__RsjvmmHD__"